import { LogLevel } from "../logger";
import { mapAnalyticsDomainToInteractionName, } from "../event/domain";
export var FullStoryLogLevel;
(function (FullStoryLogLevel) {
    FullStoryLogLevel[FullStoryLogLevel["Log"] = 0] = "Log";
    FullStoryLogLevel[FullStoryLogLevel["Debug"] = 1] = "Debug";
    FullStoryLogLevel[FullStoryLogLevel["Info"] = 2] = "Info";
    FullStoryLogLevel[FullStoryLogLevel["Warn"] = 3] = "Warn";
    FullStoryLogLevel[FullStoryLogLevel["Error"] = 4] = "Error";
    FullStoryLogLevel[FullStoryLogLevel["Assert"] = 5] = "Assert";
})(FullStoryLogLevel || (FullStoryLogLevel = {}));
export class FullStoryAdapter {
    api;
    opts;
    #currentPage = void 0;
    constructor(api, opts) {
        this.api = api;
        this.opts = opts;
    }
    emit(...events) {
        for (const evt of events) {
            const eventType = mapAnalyticsDomainToInteractionName(evt.domain);
            this.api.event(eventType, {
                domain: evt.domain,
                ...evt.context,
                eventSubType: evt.eventName,
            });
        }
    }
    viewPage(pageName, params) {
        this.#currentPage = new this.opts.FSPage(pageName, params);
        try {
            this.#currentPage.start();
        }
        catch {
            // do nothing
        }
    }
    updatePage(params) {
        if (this.#currentPage) {
            this.#currentPage.update(params ?? {});
        }
    }
    unloadPage() {
        this.#currentPage?.end();
    }
    log(level, message) {
        this.api.log(this.toFullStoryLogLevel(level), message);
    }
    anonymize() {
        this.api.anonymize();
        return Promise.resolve();
    }
    identify(userVars) {
        this.api.identify(userVars.id, userVars);
        return Promise.resolve();
    }
    toFullStoryLogLevel = (level) => {
        switch (level) {
            case LogLevel.DEFAULT: {
                return FullStoryLogLevel.Log;
            }
            case LogLevel.DEBUG: {
                return FullStoryLogLevel.Debug;
            }
            case LogLevel.INFO: {
                return FullStoryLogLevel.Info;
            }
            case LogLevel.WARN: {
                return FullStoryLogLevel.Warn;
            }
            case LogLevel.ERROR: {
                return FullStoryLogLevel.Error;
            }
            case LogLevel.FAIL: {
                return FullStoryLogLevel.Assert;
            }
            default: {
                return FullStoryLogLevel.Log;
            }
        }
    };
    addSessionContext(_newContext) {
        // No-op
    }
}
//# sourceMappingURL=fullStoryAdapter.js.map